import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { SoecoButton } from "../../components/SoecoButton";
import PrintIcon from "@mui/icons-material/Print";
import { Product } from "../../types";

type Props = {
    companyId: string;
    inventoryId: string;
    handlePrint: () => void;
    merged: boolean;
};

export const InventoryOptions = (props: Props) => {
    const navigate = useNavigate();
    return (
        <InventoryOptionsWrapper>
            <ActionButtons merged={props.merged} inventoryId={props.inventoryId}>
                <PrintButtonWrapper>
                    <SoecoButton
                        fullWidth
                        size="large"
                        color="secondary"
                        onClick={() => {
                            props.handlePrint();
                        }}
                        startIcon={<PrintIcon />}
                    >
                        {/* Print */}
                        READ / CONNECT QR-CODE
                    </SoecoButton>
                </PrintButtonWrapper>
                <SoecoButton
                    fullWidth
                    size="large"
                    color="warning"
                    onClick={() => {
                        navigate(`/companies/${props.companyId}/inventories`);
                        sessionStorage.removeItem("inventoryPage");
                    }}
                >
                    Back
                </SoecoButton>
                {props.merged ||
                props.inventoryId === "f4c7c6b0-3c4b-4c3b-9c9b-0b0b0b0b0b0b" ? null : (
                    <SoecoButton
                        fullWidth
                        size="large"
                        onClick={() =>
                            navigate(
                                `/companies/${props.companyId}/inventories/${props.inventoryId}/products/new`,
                            )
                        }
                        color="primary"
                    >
                        New product
                    </SoecoButton>
                )}
            </ActionButtons>
        </InventoryOptionsWrapper>
    );
};

const InventoryOptionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ActionButtons = styled.div<{ merged: boolean; inventoryId: string }>`
    display: grid;
    height: 10vh;
    width: 95%;
    gap: 1rem;
    position: fixed;
    bottom: 2rem;
    // grid-template-columns: 1fr 1fr;
    grid-template-columns: ${({ merged, inventoryId }) =>
        merged || inventoryId === "f4c7c6b0-3c4b-4c3b-9c9b-0b0b0b0b0b0b" ? "1fr" : "1fr 1fr"};
`;

export const PrintButtonWrapper = styled.div`
    grid-column: span 2;
`;
